import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';
import { i18n } from 'config/locales';
import { ErrorList } from 'components/ErrorList';
import SectionNavigation from 'components/Section/shared/SectionNavigation';
import { CITIZENSHIP } from 'constants/sections';
import { formTypes } from 'config/formTypes';
import { rootSelectors } from '@redux/modules/selectors';
import Intro from './Intro';
import ConnectedUsPassport from './UsPassport';
import ConnectedStatus from './Status';
import ConnectedMultiple from './Multiple';
import ConnectedPassports from './Multiple/Passports';
import ConnectedReview from './Review';
import SectionNotFound from '../shared/SectionNotFound';

const Citizenship = ({
  subsection, location, formType, isReview
}) => {
  const subsectionLibrary = {
    intro: Intro,
    passport: ConnectedUsPassport,
    status: ConnectedStatus,
    multiple: ConnectedMultiple,
    passports: ConnectedPassports,
    review: ConnectedReview,
  };

  const form = formTypes[formType];
  const section = form.find((s) => s.key === CITIZENSHIP);
  const subsectionClasses = `view view-${subsection.name || 'unknown'}`;
  const title = isReview && i18n.t('review.title');
  const para = isReview && i18n.m('review.para');

  return (
    <div className="section-view">
      {title && <h1 className="title">{title}</h1>}
      {para}

      <div className={subsectionClasses}>
        {isReview && (
          <div className="top-btns">
            <ErrorList />
          </div>
        )}

        <Switch>
          {section.subsections.map((sub) => (
            <Route
              key={sub.key}
              path={`/form/${section.path}/${sub.path}`}
              component={subsectionLibrary[sub.name]}
            />
          ))}
          <Route component={SectionNotFound} />
        </Switch>
        <SectionNavigation currentPath={location.pathname} />
      </div>
    </div>
  );
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  subsection: state.section.subsection,
  isReview: rootSelectors.section.getIsSectionInReview(state),
  formType: rootSelectors.application.getFormType(state),
  applicant: rootSelectors.application.getApplicantName(state),
});

Citizenship.propTypes = {
  subsection: PropTypes.object,
  location: PropTypes.object,
  formType: PropTypes.string.isRequired,
  isReview: PropTypes.bool,
};

Citizenship.defaultProps = {
  subsection: {},
  location: {},
};

export const CitizenshipSections = () => <ConnectedReview />;

export default connect(mapStateToProps)(Citizenship);
